import { create } from 'zustand'

import {
  DEFAULT_MAX_SEND_AMOUNT,
  DEFAULT_MIN_SEND_AMOUNT,
} from '@/utils/feeCalculations'

type SendLimitsStore = {
  minSendAmount: number
  maxSendAmount: number
  setLimits: (min: number, max: number) => void
}

export const useSendLimitsStore = create<SendLimitsStore>((set) => ({
  minSendAmount: DEFAULT_MIN_SEND_AMOUNT,
  maxSendAmount: DEFAULT_MAX_SEND_AMOUNT,
  setLimits: (min: number, max: number) =>
    set({ minSendAmount: min, maxSendAmount: max }),
}))
